var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "defaultSeat",
      style: { backgroundImage: "url(" + _vm.chartData.defaultImg + ")" },
    },
    [
      _c("div", { staticClass: "error-description" }, [
        _vm._v("当前图表无数据"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }